import { canAccessOtCosting } from './otCostingAccess';

const WELFARE_OPEN_DEPTS = new Set(['IT Development', 'ทรัพยากรบุคคล']);
const WELFARE_HR_ADMIN_DEPTS = new Set(['บุคคล', 'ทรัพยากรบุคคล']);
const WELFARE_HR_SUPER_CODES = new Set(['012539', '001005']);

function orgLevel5(emp) {
  const raw = emp?.organization;
  if (!raw) return '';
  let org = raw;
  if (typeof raw === 'string') {
    try {
      org = JSON.parse(raw);
    } catch {
      return '';
    }
  }
  return String(org?.level5 || '').trim();
}

/** แผนก HR / IT Dev เข้าได้ทุก rank; แผนกอื่นใช้เกณฑ์เดียวกับ OT (Manager ขึ้นไป) */
export function canAccessManageWelfare(emp) {
  if (!emp) return false;
  const dept = orgLevel5(emp);
  if (dept && WELFARE_OPEN_DEPTS.has(dept)) return true;
  return canAccessOtCosting(emp);
}

/**
 * ฝ่ายบุคคล / ทรัพยากรบุคคล หรือรหัสพิเศษ — เงินค้ำ / Policy / Export / batch damage
 */
export function canManageWelfareHrAdmin(emp) {
  if (!emp) return false;
  if (WELFARE_HR_SUPER_CODES.has(String(emp.employeeCode || '').trim())) return true;
  return WELFARE_HR_ADMIN_DEPTS.has(orgLevel5(emp));
}

/** Match getAllEmployees row from JWT (same rules as payroll / nav). */
export function matchEmployeeFromToken(employees, decodedToken) {
  if (!decodedToken || !employees?.length) return null;
  return (
    employees.find(
      (employee) =>
        (employee.username &&
          decodedToken?.initials &&
          employee.username === decodedToken.initials) ||
        (employee.employeeCode &&
          decodedToken?.UserCode &&
          employee.employeeCode === decodedToken.UserCode) ||
        (employee.email &&
          decodedToken?.Email &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.Email.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.mail &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.mail.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.preferred_username &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.preferred_username.replace(/\s/g, '').toLowerCase()) ||
        (employee.email &&
          decodedToken?.userPrincipalName &&
          employee.email.replace(/\s/g, '').toLowerCase() ===
            decodedToken.userPrincipalName.replace(/\s/g, '').toLowerCase())
    ) || null
  );
}
